import { Instance, types, addMiddleware } from 'mobx-state-tree'

import { t } from '../../../../translations'
import { DraftJobFields } from './fields'
import { DraftJobInstance } from '../draft-job'

export const AccomodationModel = types
  .model('Accomodation', {
    use_accommodation: types.optional(types.boolean, false),
    value: types.maybeNull(types.boolean),
    error: types.maybeNull(types.string),
  })
  .views(self => ({
    get hasError() {
      return self.error !== null
    },
  }))
  .actions(self => ({
    useAccommodation(accommodationOffered: boolean) {
      self.use_accommodation = accommodationOffered
      self.value = accommodationOffered
      self.error = null
    },

    validate() {
      if (self.use_accommodation && self.value === null) {
        self.error = t('job_draft_details.accommodation_required')
        return false
      }
      self.error = null
      return true
    },
  }))

export function createAccomodationMiddleware(targetInstance: DraftJobInstance) {
  addMiddleware(targetInstance, (call, next, abort) => {
    if (call.type === 'action' && call.args[0] === DraftJobFields.accommodation) {
      return abort(targetInstance.accommodation.validate())
    }
    return next(call)
  })
}

export type AccomodationInstance = Instance<typeof AccomodationModel>
